const gameTypes = new Set(['puck', 'openttd'])

export function serverIcon(server) {
  if (server.icon && server.icon !== 'none') return server.icon
  const type = typeof server.type === 'string' ? server.type.toLowerCase() : ''
  return gameTypes.has(type) ? type : (server.icon || 'none')
}
